(function () {
  "use strict";

  var ATTR_OPPREF = "_openai_oppref";
  var ATTR_OBREF = "_openai_obref";
  var ATTR_CONSENT = "_openai_measurement_consent";
  var MAX_OPPREF_LENGTH = 512;
  var PRIVACY_API_RETRIES = 50;
  var PRIVACY_API_RETRY_MS = 100;
  var lastPayload = "";
  var privacyApiAttempts = 0;

  function privacyApi() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function measurementAllowed() {
    var api = privacyApi();
    if (!api || typeof api.marketingAllowed !== "function" ||
        typeof api.analyticsProcessingAllowed !== "function") return false;
    return api.marketingAllowed() && api.analyticsProcessingAllowed();
  }

  function cookie(name) {
    var prefix = name + "=";
    var parts = document.cookie ? document.cookie.split(";") : [];
    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) return decodeURIComponent(part.slice(prefix.length));
    }
    return "";
  }

  function currentOppref() {
    var value = new URL(window.location.href).searchParams.get("oppref") || "";
    if (!value || value.length > MAX_OPPREF_LENGTH) return "";
    return value;
  }

  function postAttributes(attributes) {
    var payload = JSON.stringify({attributes: attributes});
    if (payload === lastPayload) return;
    lastPayload = payload;
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {"Content-Type": "application/json", "Accept": "application/json"},
      credentials: "same-origin",
      body: payload,
      keepalive: true
    }).catch(function () { lastPayload = ""; });
  }

  function syncAttribution() {
    if (!privacyApi()) {
      if (privacyApiAttempts < PRIVACY_API_RETRIES) {
        privacyApiAttempts += 1;
        window.setTimeout(syncAttribution, PRIVACY_API_RETRY_MS);
      }
      return;
    }

    if (!measurementAllowed()) {
      sessionStorage.removeItem(ATTR_OPPREF);
      if (sessionStorage.getItem("_openai_attribution_synced") === "yes") {
        postAttributes((function () {
          var denied = {};
          denied[ATTR_OPPREF] = "";
          denied[ATTR_OBREF] = "";
          denied[ATTR_CONSENT] = "denied";
          return denied;
        })());
        sessionStorage.removeItem("_openai_attribution_synced");
      }
      return;
    }

    var landingOppref = currentOppref();
    if (landingOppref) sessionStorage.setItem(ATTR_OPPREF, landingOppref);
    var attributes = {};
    attributes[ATTR_OPPREF] = sessionStorage.getItem(ATTR_OPPREF) || "";
    attributes[ATTR_OBREF] = cookie("__obref") || "";
    attributes[ATTR_CONSENT] = "granted";
    postAttributes(attributes);
    sessionStorage.setItem("_openai_attribution_synced", "yes");
  }

  function start() {
    document.addEventListener("visitorConsentCollected", syncAttribution);
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures(
        [{name: "consent-tracking-api", version: "0.1"}],
        function (error) {
          if (!error) syncAttribution();
        }
      );
    } else {
      syncAttribution();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, {once: true});
  } else {
    start();
  }
})();
